module.exports = __webpack_public_path__ + "img/blind-eye.a7a19212.svg";